<template>
	<div class="footer-block">
		<div class="footer-block_middle">
			<div class="wrapper">
				<div class="footer-block_row __justify __center">
					<div class="footer-block_col">
						<div class="footer-block_copy">© {{ year }}, ООО «Квантум А Рус»</div>
					</div>
					<div class="footer-block_col">
						<a href="" class="footer-block_terms" target="_blank">Пользовательское соглашение</a>
					</div>
					<div class="footer-block_col">
						<div class="footer-block_logo">
							<span>для</span>
							<img src="/img/beelogo.png">
						</div>
					</div>
				</div>
	
				<div class="footer-block_text">Доступ к материалам сайта предоставляется по подписке, первые 7 дней бесплатно, далее 8 ₽ (включая НДС) за 1 день.
					Только для абонентов ПАО «ВымпелКом». Продление доступа происходит автоматически, посредством Подписки. Для
					<a class="popup" href="">управления подпиской</a> и отказа от предоставления
					Подписки на услугу отправьте SMS-сообщение со словом Стоп на номер 1054 для абонентов ПАО
					«ВымпелКом» (сообщение бесплатно в домашнем регионе). Контактная информация службы технической поддержки
					Контент-провайдера: 8-800-505-42-60 (звонок бесплатный), support@quantum-a.co.
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		computed: {
			year() {
				return moment().format('YYYY');
			}
		}
	}
</script>